// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nselect[data-v-b974eed4] {\n  width: 150px\n}\nselect option[value=\"\"][disabled][data-v-b974eed4] {\n display: none;\n}\n.popup_wrap[data-v-b974eed4]{\n  -ms-overflow-style: none;\n}\n.popup_wrap[data-v-b974eed4]::-webkit-scrollbar{\n  display:none;\n}\n", ""]);
// Exports
module.exports = exports;
